import type { ReactNode } from 'react'

// A few ways to see the same things, as a row of icon pills with their names beside them on a computer. On a phone
// or tablet the icons stand alone so the switch fits beside a search box or a filter.
export function ViewSwitch<T extends string>({
  label,
  value,
  options,
  onChange,
}: {
  label: string
  value: T
  options: [T, string, ReactNode][]
  onChange: (value: T) => void
}) {
  return (
    <div role="group" aria-label={label} className="flex shrink-0 gap-0.5 self-start rounded-full bg-secondary p-0.5">
      {options.map(([option, name, icon]) => (
        <button
          key={option}
          type="button"
          aria-pressed={value === option}
          onClick={() => onChange(option)}
          className="flex h-9 items-center gap-1.5 rounded-full px-3.5 text-sm font-medium text-muted-foreground transition-colors outline-none hover:text-foreground focus-visible:ring-[3px] focus-visible:ring-ring/50 aria-pressed:bg-brand aria-pressed:text-brand-foreground pointer-coarse:h-11"
        >
          {icon}
          <span className="max-lg:sr-only">{name}</span>
        </button>
      ))}
    </div>
  )
}
